'use strict';
/* global angular */
( function () {
	function reportDatepicker () {
		return {
			'restrict'         : 'E',
			'templateUrl'      : '/templates/report/report-components/report-datepicker/report-datepicker.html',
			'controller'       : 'reportDatepickerController',
			'controllerAs'     : 'vm',
			'bindToController' : true,
			'scope'            : {
				'reportTitle'   : '@',
				'model'         : '=',
				'toggleHandler' : '&',
				'isOpen'        : '=',
				'minDate'       : '=',
				'maxDate'       : '='
			}
		};
	}

	angular
		.module( 'app.report' )
		.directive( 'reportDatepicker', reportDatepicker );
} )();
